import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id DEC0A182-36E6-47D2-ABC4-AF717946C412
 * name video-minus-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-minus-outline.svg
 * tags
 * - Video / Movie 
 */
export const VideoMinusOutlineIcon = createSvgIcon(<><path d="M15 8V16H5V8H15M16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6M13 13H7V11H13V13Z" /></>, 'VideoMinusOutlineIcon');
export default VideoMinusOutlineIcon